"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Created by inf011 on 15/08/2016.
 */

var mobx_1 = require("mobx");

var OpenState =
/** @class */
function () {
  function OpenState(appState) {
    this.url = '';
    this.browser = '';
    this.appState = appState;
  } // Obrir una url a la mateixa finestra


  OpenState.prototype.goUrl = function (url) {
    window.location.href = url;
  }; // Obrir una url a una finestra nova


  OpenState.prototype.openInNewTab = function (url) {
    var newWindow = window.open(url, '_blank', 'noopener,noreferrer');

    if (newWindow) {
      newWindow.opener = null;
    }
  };

  OpenState.prototype.resetUrl = function () {
    this.url = '';
    this.browser = '';
  }; // Obrir una nova finestra segons navegador


  OpenState.prototype.openUrl = function (url, browser) {
    var _this = this;

    var br = browser || this.getDefaultBrowser(url);

    if (br === 'chrome') {
      this.openInNewTab(url);
    } else {
      this.browser = br;
      this.url = url;
      setTimeout(function () {
        _this.resetUrl();
      }, 100);
    }
  };

  OpenState.prototype.getHostWfServer = function () {
    var entorn = this.appState.config.entorn;
    return !entorn || entorn === 'Producció' ? 'wfserver' : 'pre-wfserver';
  };

  OpenState.prototype.getDefaultBrowser = function (urlDesti) {
    var servers = [{
      server: 'wfserver',
      browser: 'chrome'
    }, {
      server: 'intranetserver',
      browser: 'chrome'
    }, {
      server: 'inetserver',
      browser: 'ie'
    }, {
      server: 'intranserver',
      browser: 'ie'
    }];
    var browser = (servers.find(function (_a) {
      var server = _a.server;
      return urlDesti.indexOf(server) >= 0;
    }) || {
      browser: 'chrome'
    }).browser;
    return browser;
  };

  OpenState.prototype.getUrlSessio = function (urlDesti, recCod) {
    var sesCod = this.appState.sessState.sessioId;
    var urlDest = encodeURIComponent(urlDesti); // Salt a WFServer

    if (urlDesti.indexOf('wfserver') >= 0) {
      var p = urlDesti.indexOf('/', urlDesti.indexOf('wfserver/') + 'wfserver/'.length);

      if (p < 0) {
        return urlDesti + "/sessio/" + sesCod;
      } else {
        return urlDesti.substr(0, p) + "/sessio/" + sesCod + urlDesti.substr(p);
      } // Salt a Intranetserver

    } else if (urlDesti.indexOf('intranetserver') >= 0) {
      return "http://intranetserver/intranet/sessio?SesCod=" + sesCod + "&UrlDesti=" + urlDest; // Salt a Intranserver
    } else {
      return "http://intranserver/intranet/aspx/Sessio/?SesCod=" + sesCod + "&RecCod=" + recCod + "&UrlDesti=" + urlDest;
    }
  }; // Obre una url en una nova finestra mentenint la sessio
  // urlDesti: url a saltar
  // recCod: recurs de la nova url (es necessita només per l'intanetserver
  // browserDestí: browser a redirigir


  OpenState.prototype.openUrlSessio = function (urlDesti, recCod, browserDesti) {
    var browser = browserDesti || this.getDefaultBrowser(urlDesti);
    var url = this.getUrlSessio(urlDesti, recCod);
    this.openUrl(url, browser);
  }; // Obre una url en la mateixa finestra mentenint la sessio
  // urlDesti: url a saltar
  // recCod: recurs de la nova url (es necessita només per l'intanetserver


  OpenState.prototype.goUrlSessio = function (urlDesti, recCod) {
    var url = this.getUrlSessio(urlDesti, recCod);
    this.goUrl(url);
  };

  OpenState.prototype.showProcWF2 = function (clasCod, clasNum) {
    var urlDest = "http://intranserver/intranet/aspx/Pro/ProInst/ProInstF.aspx?pClasCod=" + clasCod + "&pClasNum=" + clasNum;
    this.openUrlSessio(urlDest, 'PRO.2005.InstF', 'ie');
  };

  OpenState.prototype.showProc = function (clasCod, clasNum, newWindow) {
    if (newWindow === void 0) {
      newWindow = true;
    } // const urlDest = `http://intranserver/intranet/aspx/Pro/ProInst/ProInstF.aspx?pClasCod=${clasCod}&pClasNum=${clasNum}`;
    // this.openUrlSessio(urlDest, 'PRO.2005.InstF', 'ie');


    var url = "http://" + this.getHostWfServer() + "/registreProcediments/registre/" + clasCod + "/" + clasNum;

    if (newWindow) {
      this.openUrlSessio(url);
    } else {
      this.goUrlSessio(url);
    }
  };

  OpenState.prototype.showDocs = function (clasCod, clasNum) {
    var urlDest = "http://wfserver/visorDocuments/" + clasCod + "/" + clasNum;
    this.openUrlSessio(urlDest); // this.openUrl(`http://wfserver/documents/#/${clasCod}/${clasNum}`, 'chrome');
  };

  __decorate([mobx_1.observable], OpenState.prototype, "url", void 0);

  __decorate([mobx_1.observable], OpenState.prototype, "browser", void 0);

  __decorate([mobx_1.action], OpenState.prototype, "resetUrl", null);

  __decorate([mobx_1.action], OpenState.prototype, "openUrl", null);

  return OpenState;
}();

exports.default = OpenState;